import type { TableColumnFormatFrontendOnly } from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import type { FrontendOnlyColumnRenderFunction } from 'components/Table/columns/frontendOnlyColumn';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderFrontendOnlyCell = <TRow,>(
  format: TableColumnFormatFrontendOnly,
  { row, context }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  return {
    content: (format.render as FrontendOnlyColumnRenderFunction<TRow>)(
      row,
      context,
    ),
    className: format.className,
    alignment: format.alignment,
  };
};
